import axios from "axios";
import { createContext, useEffect, useRef, useState } from "react";
import authService from './authService';
import { connectWebSocket } from '../components/SocketSender'; 
import checkCookie from '../utils/cookieManager';
const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const userRef = useRef(currentUser);
  const didLogoutRef = useRef(false);
  
  useEffect(() => {
    const fetchCurrentUserSession = async () => {
      if (didLogoutRef.current) {
        setCurrentUser(null);
        setLoading(false);
        return; 
      }
      try {
        const user = await authService.getCurrentUser();
        setCurrentUser(user);
      } catch {
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchCurrentUserSession();
  }, []);

  const login = async (inputs) => {
    let user;
  
    if (inputs.type === "qr") {
      // QR login
      user = await authService.loginQR({ qr: inputs.qr });
    } else {
      // Password login
      user = await authService.login({
        username: inputs.username,
        password: inputs.password,
      });
    }
  
    didLogoutRef.current = false; // reset flag after login
    setCurrentUser(user);
    return user;
  };
  

const logout = async () => {
  didLogoutRef.current = true;

  try {
    // Ask the backend to invalidate the authentication session.
    await authService.logout();
  } catch (error) {
    console.error("Backend logout failed:", error);
  }

  // Clear the local authentication state regardless of API success.
  setCurrentUser(null);
  localStorage.removeItem("user");

  // Notify the server about the session, if one exists.
  const sessionValue = checkCookie("session_id");

  if (sessionValue !== null) {
    try {
      const socket = await connectWebSocket();

      await new Promise((resolve) => {
        const timeout = window.setTimeout(resolve, 2000);

        socket.once("session-disconnected", () => {
          window.clearTimeout(timeout);
          resolve();
        });

        socket.emit("disconnect-session", sessionValue);
      });

      // Remove the session cookie after attempting disconnection.
      document.cookie =
        "session_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
    } catch (error) {
      console.error("Session disconnection failed:", error);
    }
  }
};
  

/*
const logout = async () => {
  didLogoutRef.current = true;
  await authService.logout();
  setCurrentUser(null);
  localStorage.removeItem("user");

window.location.href = "/";
  const sessionValue = checkCookie('session_id');
  if(sessionValue !== null ) {
    const socket = await connectWebSocket();
    // TODO: add error handling here, add this to SocketSender as a method
    socket.emit("disconnect-session", sessionValue);
    socket.on("session-disconnected", msg => {
      document.cookie = "session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    });
  }
  
};
*/



  return (
    <AuthContext.Provider value={{ currentUser, userRef, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;